(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'sb-favs';
    function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
    function sync() {
      var favs = load();
      document.querySelectorAll('[data-sb-pc]').forEach(function (c) {
        var b = c.querySelector('[data-sb-fav]');
        if (b) b.setAttribute('aria-pressed', favs.indexOf(c.dataset.handle) > -1 ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sb-fav]');
      if (!b) return;
      e.preventDefault();
      var h = b.closest('[data-sb-pc]').dataset.handle;
      var favs = load();
      var i = favs.indexOf(h);
      if (i > -1) favs.splice(i, 1); else favs.push(h);
      save(favs);
      sync();
    });
    // add to cart without leaving the page (single-variant cards)
    function toast(msg) {
      var t = document.querySelector('.sb-toast');
      if (!t) { t = document.createElement('div'); t.className = 'sb-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
      t.innerHTML = msg; t.classList.add('is-on');
      clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
    }
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-sb-pc-add]');
      if (!f) return;
      e.preventDefault();
      var btn = f.querySelector('.sb-pc__btn');
      // Tesettura cart drawer present: add through it and open the drawer instead of the toast
      if (window.sbCart) {
        if (btn) btn.classList.add('is-loading');
        window.sbCart.add([{ id: +f.querySelector('[name=id]').value, quantity: 1 }])
          .catch(function () { f.submit(); })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
        return;
      }
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +f.querySelector('[name=id]').value, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js').then(function (c) { return c.json(); }); })
        .then(function (cart) {
          if (btn) { var sp = btn.querySelector('span'); btn.classList.add('is-done'); if (sp) sp.textContent = 'Eklendi ✓'; setTimeout(function () { btn.classList.remove('is-done'); if (sp) sp.textContent = 'Sepete ekle'; }, 1600); }
          document.querySelectorAll('.sb-bn2 a[href*="/cart"] .sb-bn2__ic').forEach(function (ic) {
            var b = ic.querySelector('.sb-bn2__badge'); if (!b) { b = document.createElement('b'); b.className = 'sb-bn2__badge'; ic.appendChild(b); }
            b.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'sb-product-card', data: { itemCount: cart.item_count } } }));
          toast('Sepete eklendi <a href="/cart">Sepete git →</a>');
        })
        .catch(function () { f.submit(); });
    });
    // card videos: play on hover (mouse) / while mostly in view (touch), muted and looped
    function play(v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); v.classList.add('is-play'); }
    function stop(v) { v.pause(); v.classList.remove('is-play'); }
    var touch = window.matchMedia('(hover: none)').matches;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) play(e.target); else stop(e.target); });
    }, { threshold: [0, 0.6, 1] }) : null;
    function initVids() {
      document.querySelectorAll('[data-sb-pc-vid]:not([data-i])').forEach(function (v) {
        v.setAttribute('data-i', '1');
        if (touch) { if (io) io.observe(v); }
        else {
          var card = v.closest('[data-sb-pc]');
          card.addEventListener('mouseenter', function () { play(v); });
          card.addEventListener('mouseleave', function () { stop(v); });
        }
      });
    }
    if (document.readyState !== 'loading') initVids(); else document.addEventListener('DOMContentLoaded', initVids);
    document.addEventListener('shopify:section:load', initVids);
    setTimeout(initVids, 1500);
    if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
    document.addEventListener('shopify:section:load', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
